/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_FeatureManagement_GetFeatureListResultDto } from '../models/Volo_Abp_FeatureManagement_GetFeatureListResultDto';
import type { Volo_Abp_FeatureManagement_UpdateFeaturesDto } from '../models/Volo_Abp_FeatureManagement_UpdateFeaturesDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FeaturesService {

    /**
     * @param providerName 
     * @param providerKey 
     * @returns Volo_Abp_FeatureManagement_GetFeatureListResultDto OK
     * @throws ApiError
     */
    public static getApiAwardApiFeatureManagementFeatures(
providerName?: string,
providerKey?: string,
): CancelablePromise<Volo_Abp_FeatureManagement_GetFeatureListResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/feature-management/features',
            query: {
                'providerName': providerName,
                'providerKey': providerKey,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param providerName 
     * @param providerKey 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAwardApiFeatureManagementFeatures(
providerName?: string,
providerKey?: string,
requestBody?: Volo_Abp_FeatureManagement_UpdateFeaturesDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/feature-management/features',
            query: {
                'providerName': providerName,
                'providerKey': providerKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param providerName 
     * @param providerKey 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAwardApiFeatureManagementFeatures(
providerName?: string,
providerKey?: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/feature-management/features',
            query: {
                'providerName': providerName,
                'providerKey': providerKey,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
